import React, { useContext, useEffect } from 'react';
import AppContext from 'contexts/appContext';
import Panel from 'components/common/panel/panel';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import Heading from 'components/common/heading/heading';

export default function UserDetailsPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Home, 'User Details');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Users', href: '/Users' }, { name: 'User Details', selected: true }]);
  }, []);

  return (
    <Flow>
      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-md-10 col-xl-8'>
            <Panel>
              <Panel.Body>
                <div>
                  <h2 className='text-thin mt-1'>Brenda Witherspoon</h2>
                </div>
                <div>
                  <div className='text-thick mx-2'><i className='icons8-online-shop-2 text-large mr-2' /> Dairy Queen Corporate</div>
                  <div className='text-thick mx-2'><i className='icons8-user text-large mr-2' /> Portal Manager</div>
                  <div className='text-thick mx-2'><i className='icons8-briefcase text-large mr-2' /> Accountant</div>
                </div>
                <div className='d-flex justify-content-between mt-4'>
                  <div>
                    <div className='form-label'>User Id</div>
                    <div>bwitherspoon</div>
                  </div>

                  <div>
                    <div className='form-label'>Email</div>
                    <div>bwitherspoon@positouch.com</div>
                  </div>
                </div>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </Flow.Body>
    </Flow >
  );
}